import { ChipProps } from "@mui/material";

export function getChipProps(params: string): ChipProps {
    if (params === 'assegnata'){
        return {
            label: params,
            sx: {
                "& .MuiChip-label": {
                    color: "background.default"
                },
                backgroundColor: "#c21bd5",
                borderRadius: 1
            },
        }
    }

    if (params === 'in progress'){
        return {
            label: params,
            sx: {
                "& .MuiChip-label": {
                    color: "background.default"
                },
                backgroundColor: "#45a1d8",
                borderRadius: 1
            }
        }
    }

    if (params === 'chiuso'){
        return {
            label: params,
            sx: {
                "& .MuiChip-label": {
                    color: "background.default"
                },
                backgroundColor: "#35b26b",
                borderRadius: 1
            }
        }
    }

    if (params === 'da assegnare'){
        return {
            label: params,
            sx: {
                "& .MuiChip-label": {
                    color: "background.default"
                },
                backgroundColor: "#adb5bd",
                borderRadius: 1
            }
        }
    }

    if (params === 'contestata'){
        return {
            label: params,
            sx: {
                "& .MuiChip-label": {
                    color: "background.default"
                },
                backgroundColor: "black",
                borderRadius: 1
            }
        }
    }

    return {
        label: "Errore",
        color: "error",
        sx: {
            "& .MuiChip-label": {
                color: "background.default"
            },
            borderRadius: 1
        }
    }
}
